const AUTH_API_URL = import.meta.env.VITE_AUTH_SERVICE_URL || 'http://localhost:4000';
const BACKEND_API_URL = import.meta.env.VITE_DASHBOARD_API_URL || 'http://localhost:3000/api';

/**
 * API Client for Authentication Service
 */
export const authApi = {
  async checkSession(): Promise<{ valid: boolean; email?: string; name?: string }> {
    const response = await fetch(`${AUTH_API_URL}/session-status`, {
      credentials: 'include',
    });
    return response.json();
  },

  async logout(): Promise<void> {
    await fetch(`${AUTH_API_URL}/logout`, {
      method: 'POST',
      credentials: 'include',
    });
  },

  async getProfile(): Promise<{ email: string; name?: string }> {
    const response = await fetch(`${AUTH_API_URL}/me`, {
      credentials: 'include',
    });
    const data = await response.json();
    return data.data;
  },

  async updateProfile(name: string): Promise<{ success: boolean }> {
    const response = await fetch(`${AUTH_API_URL}/me`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ name }),
    });
    return response.json();
  },
};

/**
 * API Client for Dashboard Backend
 */
export const dashboardApi = {
  async getApps() {
    const response = await fetch(`${BACKEND_API_URL}/apps`, {
      credentials: 'include',
    });
    const data = await response.json();
    return data.apps || []; // Backend returns { apps: [...], total: N }
  },

  async getFavorites() {
    const response = await fetch(`${BACKEND_API_URL}/favorites`, {
      credentials: 'include',
    });
    const data = await response.json();
    return data.favorites || []; // Backend returns { favorites: [...] }
  },

  async addFavorite(appId: string) {
    const response = await fetch(`${BACKEND_API_URL}/favorites`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ appId }),
    });
    const data = await response.json();
    return data.data;
  },

  async removeFavorite(appId: string) {
    await fetch(`${BACKEND_API_URL}/favorites/${appId}`, {
      method: 'DELETE',
      credentials: 'include',
    });
  },

  async logAccess(appId: string) {
    await fetch(`${BACKEND_API_URL}/analytics/log-access`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ appId }),
    });
  },

  async getAccessLogs(limit: number = 50) {
    const response = await fetch(
      `${BACKEND_API_URL}/analytics/access-logs?limit=${limit}`,
      {
        credentials: 'include',
      }
    );
    const data = await response.json();
    return data.data;
  },

  async getStats() {
    const response = await fetch(`${BACKEND_API_URL}/analytics/stats`, {
      credentials: 'include',
    });
    const data = await response.json();
    return data.data;
  },
};
